import * as React from 'react';
import { SVGProps } from 'react';

const IconTestSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h1v5.454l-2.849 4.144 10.772-1.346L17 11.454V6h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-8ZM20 16.108 6.436 17.803l-3.084 5.064C2.44 24.194 3.39 26 5 26h17.999c1.61 0 2.56-1.806 1.648-3.133L20 16.108Z" />
  </svg>
);
export default IconTestSizeL;
